import React from 'react';
import Loader from 'react-loader-spinner'

const CustomLoader = (props) => {
    return (
        // <div className="" style={props.customstyles} >
        //     <div>
        //     <Loader
        //         type={props.type}
        //         color={props.color}
        //         height={props.width}
        //         width={props.height}
        //     />
        //     </div>
        // </div>
        <>
        <tr>
            <td colSpan={10}>
            <Loader
                type={props.type}
                color={props.color}
                height={props.width}
                width={props.height}
            />
            </td>
        </tr>
        </>
    );
}

export default CustomLoader;

CustomLoader.defaultProps = {
    customstyles: {"marginTop":'1.5em',"marginBottom":'1.5em' },
    width: 50,
    height: 950,
    // color: "#1e8d9a",
    color:"#4fa94d",
    type: "Oval",
}